import React, { Component } from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import Select from 'react-select';
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { addApp, updateApp,weatherSearchLocation, getWeatherForcasteByLocation, getWeatherSpecificByLocation } from '../../../../../../../actions/sceneActions'
import { DISPLAY_WALL_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import WeatherIframeComp from './WeatherPreview/weatherIframe'
import WeatherSelect from './weatherSelect'
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import { stripTrailingSlash } from "../../../../../../../utils";

const duplicationRemoveFromArray = (data) => {
    let removeableData = [];
    let existingDataID = [];
    if (data && data.length > 0) {
        data.map((item) => {
            if (!existingDataID.includes(item.label)) {
                existingDataID.push(item.label);
                removeableData.push(item);
            }

        })
    }
    return removeableData;
}

class Weather extends Component {
    state = {
        language: [{ value: 'en', label: 'English' }],
        languageValue: 'en',
        temperatureUnit: [{ value: '17', label: 'Celsius' }, { value: '18', label: 'Fahrenheit' }],
        temperatureUnitText: "17",
        defaultTheme: [{ value: '0', label: 'Light' }, { value: '1', label: 'Dark' }],
        defaultThemeValue: '0',
        selectedOption: null,
        locationSearchData: [],
        options: [],
        isloading: false,
        weatherData: [],
        currentData: {},
        updateApi: false,
        loader: false,
        buttonDis: false,
        stateChanged: false,
    }
    componentWillMount() {
        const { scenes } = this.props;
        const { app_data } = scenes.updateSceneData;
        if (app_data) {
            const { languageValue, temperatureUnitText, selectedOption } = app_data;
            this.setState({
                languageValue, temperatureUnitText, selectedOption, updateApi: true
            });
        }
    }
    componentDidMount() {
        const { scenes, location } = this.props;
        const { app_data } = scenes.updateSceneData;
        if (app_data && location.pathname.includes('update')) {
            const { languageValue, temperatureUnitText, selectedOption } = app_data;
            this.setState({
                languageValue, temperatureUnitText, selectedOption, updateApi: true
            });
        }
    }
    onTextUrl = event => {
        this.setState({ url: event.target.value })
    }

    onSaveUrl = (event) => {
        const { param } = this.props;
        const { languageValue, temperatureUnitText, selectedOption } = this.state;

        if (languageValue && temperatureUnitText && selectedOption && selectedOption.length > 0) {
            this.setState({buttonDis:true, loader:true })
            this.state.updateApi
                ? this.props.updateApp(
                    param.contentMixId,
                    this.props.scenes.updateSceneData.id,
                    { languageValue, temperatureUnitText, selectedOption },
                    1,
                    this.onSaveCallBack
                )
                : this.props.addApp(
                    param.contentMixId,
                    param.positionID,
                    { languageValue, temperatureUnitText, selectedOption },
                    "Weather",
                    1,
                    this.onSaveCallBack
                );
        }
        else {
            Swal.fire({
                title: 'Error',
                text: 'Please check all input fields !',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
    };

    onBack = event => {
        const { params } = this.props.match;
        const { pathname } = this.props.location; 

        if (!this.state.stateChanged) {
            this.props.history(stripTrailingSlash(pathname,params))
            return;
          }
        
        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            // icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                Swal.fire(
                    SUCCESS_TEXT,
                    DISPLAY_WALL_SUCCESS_SAVE,
                    "success"
                )
               this.onSaveUrl();
             } else if (result.dismiss === "cancel") {
                this.props.history(stripTrailingSlash(pathname,params))

            }
        });
    }
    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_WALL_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }
        ).then((result) => {
            this.setState({buttonDis:false, loader:false })
            this.props.history(`/studio/${params.wallId}`)
        })
    }

    onSearchTextLocation = () => {

        let input = document.querySelector('#react-select-2-input');
        if (input) {
            let timeout = null;
            input.addEventListener('keyup', e => {

                clearTimeout(timeout);
                timeout = setTimeout(async () => {

                    if (input.value && input.value.length > 0 && input.value != null) {
                        await weatherSearchLocation(input.value).then((response) => {
                            const { results } = response.data;
                            let optionsData = [];
                            if (results && results.length > 0) {
                                results.map((item) => {
                                    optionsData.push({ value: item.Key, label: item.LocalizedName })
                                })

                            }
                            this.setState({ options: duplicationRemoveFromArray(optionsData), locationSearchData: results })

                            return response.data
                        })
                    }
                }, 1000);
            });
        }
    }

    handleChange = selectedOption => {
        this.setState({ selectedOption });
        // console.log(`Option selected:`, selectedOption);
    };

    handleChangeinput = event => {
        // console.log(`Option selected:`, selectedOption);
    };

    onUpdateTemperatureUnit = event => {
        this.setState({ temperatureUnitText: event.value }, () => this.onGetweatherByLocation())
    }
    onUpdateLanguage = event => {
        this.setState({ languageValue: event.value, stateChanged : true })
    }
    onUpdateDefaltTheme = event => {
        this.setState({ defaultThemeValue: event.value, stateChanged : true })
    }
    onUpdateLocation = (value) => {
        this.setState({ selectedOption: value, stateChanged : true }, () => {

        })
    }

    onUpdateWeatherData = (value) => {
        this.setState({ weatherData: value }, () => {
        })
    }
    onUpdateCurrentData = (value) => {
        this.setState({ currentData: value }, () => {

        })
    }


    onGetweatherByLocation = async () => {
        const { selectedOption, languageValue, temperatureUnitText } = this.state;
        if (selectedOption && selectedOption.length > 0 && selectedOption[0].value && languageValue && temperatureUnitText) {
            await getWeatherForcasteByLocation(selectedOption[0].value, languageValue, temperatureUnitText).then((response) => {
                const data = response.data[selectedOption[0].value];
                this.onUpdateWeatherData(data)
                this.setState({stateChanged : true})
            })
            await getWeatherSpecificByLocation(selectedOption[0].value).then((response) => {
                const data = response.data[selectedOption[0].value];
                this.onUpdateCurrentData(data)
                this.setState({stateChanged : true})
            })
        }

    }



    render() {
        const { match, name } = this.props;
        const { url, language, languageValue, temperatureUnit,buttonDis,loader, selectedOption, options, isloading, temperatureUnitText, defaultTheme, defaultThemeValue, updateApi } = this.state;
        const { pathname } = this.props.location; 

        return (<>

            <NavigationHeader
                name={name} 
                backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
            /> 

            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            {/* <Form.Group controlId="formBasicEmail">
                                                <Form.Label>Language*</Form.Label>
                                                <Select
                                                    value={language.find(option => option.value === languageValue)}
                                                    onChange={this.onUpdateLanguage}
                                                    options={language}
                                                />
                                            </Form.Group> */}
                                            <Form.Group className="form-group" controlId="formBasicEmail">
                                                <Form.Label>Show Temperature Unit</Form.Label>
                                                <Select
                                                    value={temperatureUnit.find(option => option.value === temperatureUnitText)}
                                                    onChange={this.onUpdateTemperatureUnit}
                                                    options={temperatureUnit}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="formBasicEmail">
                                                <Form.Label>Location</Form.Label>
                                                {/* <ReactSelect/> */}
                                                <WeatherSelect onUpdateLocation={this.onUpdateLocation} languageValue={languageValue} temperatureUnitText={temperatureUnitText} onUpdateWeatherData={this.onUpdateWeatherData} onUpdateCurrentData={this.onUpdateCurrentData} selectedOption={selectedOption} updateApi={updateApi} />
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="formBasicEmail">
                                                <Form.Label>Theme</Form.Label>

                                                <Select
                                                    value={defaultTheme.find(option => option.value === defaultThemeValue)}
                                                    onChange={this.onUpdateDefaltTheme}
                                                    options={defaultTheme}
                                                    isSearchable={false}
                                                />
                                            </Form.Group>

                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button disabled={ buttonDis } variant="primary" className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} onClick={this.onSaveUrl} id="Studio_Weather_App_Users">Save</Button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                
                                                { this.state.currentData && this.state.currentData.length  ?  
                                                <WeatherIframeComp weatherData={this.state.weatherData} currentData={this.state.currentData} selectedOption= {this.state.selectedOption} defaultThemeValue={this.state.defaultThemeValue} />
                                                    :
                                                  <div className="studio-prieview">Please Enter Location</div>
                                                 }
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>
        </>);
    }
}
const mapStateToProps = state => {
    return {
        studioWall: state.studio.studioWall,
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
            dispatch(
                addApp(contentMixId, position, appContent, appName, appId, callBack)
            ),
        updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
            dispatch(
                updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
            ),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Weather);